import { css } from 'lit';

export const reducedMotionRule = css`
  :host,
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-delay: 0s !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    transition-delay: 0s !important;
    scroll-behavior: auto !important;
  }
`;

export const nsReducedMotionStyles = css`
  @media (prefers-reduced-motion: reduce) {
    ${reducedMotionRule}
  }
`;

export const nsMotionKeyframes = css`
  @keyframes ns-fade-in {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
  }
`;
